module.exports = __webpack_public_path__ + "media/images/area-badges/atmospheric-conditions-8bbe3876faf804fab8ced188bd829564.svg";